module.exports = __webpack_public_path__ + "img/knu_gallery14.ed16c200.jpg";